import { InputReviewCreate } from "@scrile/api-provider/dist/api/ReviewProvider";
import providers from "../../lib/providers";

export default function useController(appointmentId: string) {
  const publishFeedback = async (comment: string) => {
    const data = {
      subject: {
        subjectId: appointmentId,
        subjectType: "appointment",
      },
      comment: comment.trim(),
    } as InputReviewCreate;
    return await providers.ReviewProvider.create({ data });
  };

  return {
    publishFeedback,
  };
}
